/**
 * Created by andrey on 18.01.2021.
 */

const ShadowLayer = cc.Scale9Sprite.extend({
    ctor: function () {
        this._super(bundles.pixel.frames.pixel_png);
        this.setColor(cleverapps.styles.COLORS.BLACK);
        this.setAnchorPoint(0, 0);
        this.setOpacity(0);
        this.setVisible(false);
        this.show = false;

        this.onResize();

        const scene = cleverapps.Scenes.GetRunningScene();
        scene.addChild(this);
    },

    subscribeToModel: function () {
        cleverapps.shadow.on("show", this.createShadow.bind(this), this);
        cleverapps.shadow.on("hide", this.deleteShadow.bind(this), this);
        cleverapps.shadow.on("moveUp", this.moveUp.bind(this), this);
        cleverapps.shadow.on("moveDown", this.moveDown.bind(this), this);
    },

    onResize: function () {
        const padding = cleverapps.styles.ShadowLayer.padding;
        const rect = cleverapps.resolution.getBgRect();
        this.setContentSize(rect.width + 2 * padding, rect.height + 2 * padding);
        this.setAlignment(rect.x - padding, rect.y - padding);
    },

    createShadow: function (delayed) {
        if (this.show) {
            return;
        }

        this.show = true;
        this.stopAllActions();
        this.visible = true;

        this.onResize();
        this.runAction(
            new cc.Sequence(
                new cc.DelayTime(delayed ? 0.8 : 0),
                new cc.FadeTo(delayed ? 0.4 : 0.2, 150)
            )
        );
    },

    deleteShadow: function (delayed) {
        if (!this.show) {
            return;
        }

        this.show = false;
        this.stopAllActions();

        this.runAction(
            new cc.Sequence(
                new cc.FadeTo(delayed ? 0.4 : 0.2, 0),
                new cc.Hide()
            )
        );
    },

    moveUp: function () {
        this.setLocalZOrder(WindowComponent.WINDOWS_ZORDER + 8);
    },

    moveDown: function () {
        this.setLocalZOrder(WindowComponent.WINDOWS_ZORDER - 3);
    }
});

cleverapps.styles.ShadowLayer = {
    padding: 10
};
